var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ShadowSettings,{attrs:{"shadow":_setup.shadow,"cmyk-mode":_setup.props.cmykMode,"is-preview":_setup.props.isPreview,"variant":"image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }